import { createContext } from "react";

export const AutContext = createContext();